/*
 * React Day Picker settings
 */

export const FORMAT = 'DD MMM'

export const WEEKDAYS_LONG = [
  'Domingo',
  'Segunda',
  'Terça',
  'Quarta',
  'Quinta',
  'Sexta',
  'Sábado',
]

export const WEEKDAYS_SHORT = [
  'Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'
]

export const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

export const WEEKDAYS_NAMES = {
  0: 'Domingos',
  1: 'Segundas-feiras',
  2: 'Terças-feiras',
  3: 'Quartas-feiras',
  4: 'Quintas-feiras',
  5: 'Sextas-feiras',
  6: 'Sábados',
}

export const WEEKDAYS_PLURAL_SHORT_NAME = {
  0: 'Domingos',
  1: 'Segundas',
  2: 'Terças',
  3: 'Quartas',
  4: 'Quintas',
  5: 'Sextas',
  6: 'Sábados',
}

export const WEEKDAYS = {
  0: 'Domingo',
  1: 'Segunda-feira',
  2: 'Terça-feira',
  3: 'Quarta-feira',
  4: 'Quinta-feira',
  5: 'Sexta-feira',
  6: 'Sábado',
}

export const WEEKDAYS_WITH_START_ON_MONDAY = {
  0: 'Segunda-feira',
  1: 'Terça-feira',
  2: 'Quarta-feira',
  3: 'Quinta-feira',
  4: 'Sexta-feira',
  5: 'Sábado',
  6: 'Domingo',
}